/**
 * Fix Flickity carousels for AJAX-loaded product recommendations / recently viewed (Design 11).
 */
(function () {
  function isRecommendationsLoading($wrap) {
    return $wrap.find('.t4s-loading--bg').length > 0 && $wrap.find('.t4s-product').length === 0;
  }

  function fixProductSliders() {
    if (typeof jQuery_T4NT === 'undefined' || typeof T4SThemeSP === 'undefined' || !T4SThemeSP.Carousel) {
      return;
    }

    var $ = jQuery_T4NT;

    $('#pr_recommendations, #recently_wrap').each(function () {
      var $wrap = $(this);
      var $section = $wrap.closest('.id_product-recommendations, .id_recently_viewed, .t4s-section');

      if ($wrap.find('.t4s-product').length === 0) {
        if (isRecommendationsLoading($wrap)) {
          return;
        }
        if ($section.length) {
          $section.hide();
        }
        return;
      }

      if ($section.length) {
        $section.show();
      }

      $wrap.find('.flickityt4s').each(function () {
        var el = this;
        if (el.flickityt4s) {
          $(el).flickityt4s('resize');
        } else {
          el.flickityt4s = new T4SThemeSP.Carousel(el);
        }
      });

      if (T4SThemeSP.ProductItem && T4SThemeSP.ProductItem.resizeObserver) {
        T4SThemeSP.ProductItem.resizeObserver();
      }
    });
  }

  function scheduleFix() {
    var delays = [800, 2500, 5000];
    function runAll() {
      delays.forEach(function (ms) {
        setTimeout(fixProductSliders, ms);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', runAll);
    } else {
      runAll();
    }
  }

  scheduleFix();

  document.addEventListener('shopify:section:load', fixProductSliders);
})();
